import { AfterContentInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChartDataService } from '../../../helpers/chart-data.service';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-graph-dialog',
  templateUrl: './graph-dialog.component.html',
  styleUrl: './graph-dialog.component.scss'
})
export class GraphDialogComponent implements OnInit, AfterContentInit {

  startDate: Date;
   endDate: Date;
   categoryIds: number[];
   companyId: number;
   whichGraph:number

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GraphDialogComponent>,
    private cdr:ChangeDetectorRef,
    private dashboardService: DashboardService, private chartDataService: ChartDataService) {
    this.whichGraph = data.whichGraph;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.categoryIds = data.categoryIds;
    this.companyId = data.companyId;
    }
  ngAfterContentInit(): void {
    this.cdr.detectChanges();
  }
  
  ngOnInit(): void {
    const companyIdval = localStorage.getItem('companyId');
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;
  }
}
